import { Position, Toaster, Intent } from "@blueprintjs/core";

const toaster = Toaster.create({
    position: Position.TOP,
})

export const showError = (err: any) => {
    if (err.response) {
        toaster.show({ message: err.response.data.description, intent: Intent.WARNING })
    } else if (err.request) {
        toaster.show({ message: "Request failed", intent: Intent.WARNING })
    } else if (err.message) {
        toaster.show({ message: err.message, intent: Intent.WARNING })
    } else {
        toaster.show({ message: err, intent: Intent.WARNING })
    }
}

export const showSuccess = (message: string) => {
    toaster.show({ message: message, intent: Intent.SUCCESS, timeout: 8000 })
}

export function handleStringChange(handler: (value: string) => void) {
    return (event: React.FormEvent<HTMLElement>) => handler((event.target as HTMLInputElement).value);
}

export function handleBooleanChange(handler: (checked: boolean) => void) {
    return (event: React.FormEvent<HTMLElement>) => handler((event.target as HTMLInputElement).checked);
}

export function handleNumberChange(handler: (value: number) => void) {
    return handleStringChange(value => handler(+value));
}

export function drValue(n: any): string {
    if (typeof n === "number" && n > 0)
        return n.toLocaleString(undefined, { minimumFractionDigits: 2 });
    return ""
}

export function crValue(n: any): string {
    if (typeof n === "number" && n < 0)
        return (-n).toLocaleString(undefined, { minimumFractionDigits: 2 });
    return ""
}

export function formatMoney(n: any, d:number = 2): string {
    //if (typeof n === "number")
        return roundMoney(Number(n), d).toLocaleString(undefined, { minimumFractionDigits: d });
    //return ""
}

export function formatNumber(n: any): string {
    if (typeof n === "number")
        return n.toLocaleString();
    return ""
}

export function numToString(n: any): string {
    if (typeof n === "number")
        return n.toString();
    return ""
}

export function StringToNum(x: any): number {
    if (typeof x === "number") {
        return x;
    }
    let n = Number.parseFloat(x)
    return Number.isNaN(n) ? 0 : n
}

export function formatDate(date: Date): string {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [year, month, day].join('-');
}

export function formatDateMin(date1: Date, date2: Date): string {
    var date = date1
    if (date2 && date1 > date2) {
        date = date2
    }
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [year, month, day].join('-');
}

export function roundMoney(n: any, d:number = 2): number {
    if (typeof n === "number")
        return Number.parseFloat(n.toFixed(d));
    return 0
}

export function fileSize(n: number): string {
    if (n >= 1024**3) {
        return (n / (1024**3)).toFixed(1)+" TB"
    }
    if (n >= 1024**2) {
        return (n / (1024**2)).toFixed(1)+" MB"
    }
    if (n >= 1024) {
        return (n / (1024)).toFixed(1)+" KB"
    }
    return n.toLocaleString()
}

export function fileBase(path: string): string {
    return path.replace(/^.*\\/, "");
}

//           1
// 01234567890123456
// yyyymmddhhmmssfff
export function hb_StoD(s: string): Date {
    let dateString = s.slice(0,4)+'-'+s.slice(4,6)+'-'+s.slice(6,8)+'T'+s.slice(8,10)+':'+s.slice(10,12)+':'+s.slice(12,14)+'.'+s.slice(14,17)
    return new Date(dateString)
}

export function formatTime(d: Date): string {
    return d.toLocaleTimeString([], {hour12: false})
}

export function acTypeName(acType: string): string {
    let acTypeName = acType

    switch (acType) {
        case 'A':
            acTypeName = 'asset'
            break;
        case 'L':
            acTypeName = 'liability'
            break;
        case 'C':
            acTypeName = 'capital'
            break;
        case 'I':
            acTypeName = 'revenue'
            break;
        case 'E':
            acTypeName = 'expense'
            break;
    }
    return acTypeName
}

export function numTypeName(numType: string): string {
    let numTypeName = numType

    switch (numType) {
        case 'J':
            numTypeName = 'journal'
            break;
    }
    return numTypeName
}

export function cashFlowTypeName(cashFlowType: string): string {
    let cashFlowTypeName = cashFlowType

    switch (cashFlowType) {
        case '':
            cashFlowTypeName = 'none'
            break;
        case 'O':
            cashFlowTypeName = 'operating'
            break;
        case 'I':
            cashFlowTypeName = 'investing'
            break;
        case 'F':
            cashFlowTypeName = 'financial'
            break;
        case 'C':
            cashFlowTypeName = 'cash'
            break;
    }
    return cashFlowTypeName
}

export function partyTypeName(partyType: string): string {
    let partyTypeName = partyType

    switch (partyType) {
        case 'C':
            partyTypeName = 'customer'
            break;
        case 'V':
            partyTypeName = 'vendor'
            break;
    }
    return partyTypeName
}

const _MS_PER_DAY = 1000 * 60 * 60 * 24;

// a and b are javascript Date objects
export function dateDiffInDays(a: Date, b: Date) {
    // Discard the time and time-zone information.
    const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
    const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

    return Math.floor((utc2 - utc1) / _MS_PER_DAY);
}

export function isInPeriod(a: Date, b: Date, from: number, to: number) {
    let days = dateDiffInDays(a, b)
    //console.log(from, days, to, (from <= days) && (days <= to))
    return (from <= days) && (days <= to)
}

export function journalBase(journalType?: string) {
    if (journalType === "AR") {
        return "receivables"
    } else if (journalType === "AP") {
        return "payables"
    } else if (journalType === "R") {
        return "receipts"
    } else if (journalType === "P") {
        return "payments"
    } else {
        return "vouchers"
    }
}

export function isEmpty(obj: object) {
    for (const prop in obj) {
      if (Object.hasOwn(obj, prop)) {
        return false;
      }
    }
  
    return true;
  }